var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 353,
    viewBox: "0 0 1280 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 353,
    fill: "#303376"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_41_3)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1095.31 224.503C1149.06 224.503 1192.63 180.962 1192.63 127.251C1192.63 73.5409 1149.06 30 1095.31 30C1041.57 30 998 73.5409 998 127.251C998 180.962 1041.57 224.503 1095.31 224.503Z",
    fill: "url(#paint0_linear_41_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.22 325.165C1023.61 342.227 1004.83 390 1004.83 390C1004.83 390 1001.92 348 1013.37 325.165C1027.36 297.247 1052.63 285.923 1074.83 273.982C1097.02 262.038 1137.81 258.672 1167.02 233.032C1192.45 210.707 1204.15 195.704 1213.11 163.08C1223.38 125.725 1206.29 64.123 1206.29 64.123C1206.29 64.123 1262.62 115.308 1269.45 139.194C1276.28 163.08 1281.41 192.085 1276.28 221.091C1271.16 250.094 1253.01 269.836 1223.36 285.923C1163.6 318.342 1078.12 305.909 1049.22 325.165Z",
    fill: "#F05D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.07 91.4219C1235.07 91.4219 1236.53 92.749 1239.01 95.0724C1253.26 110.33 1267.68 127.843 1270.93 139.194C1277.76 163.08 1282.88 192.085 1277.76 221.089C1272.64 250.095 1254.49 269.838 1224.83 285.926C1177.99 311.335 1115.35 309.189 1076.53 316.349C1085.44 310.7 1094.77 306.038 1103.62 301.28C1125.81 289.336 1166.6 285.971 1195.81 260.331C1221.24 238.006 1232.94 223.002 1241.9 190.38C1252.17 153.025 1235.07 91.4219 1235.07 91.4219Z",
    fill: "#B0324B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_3",
    x1: 1163.6,
    y1: 72.654,
    x2: 1023.67,
    y2: 175.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252850"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 353,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_41_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 360,
    fill: "white",
    transform: "translate(998 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoFooter);
export default __webpack_public_path__ + "static/media/fondo_footer.fbee5071d12d05da4982902dcdcce22d.svg";
export { ForwardRef as ReactComponent };